export const CHECKOUT_URL = 'https://yoga-teaching-vault.impultienda.ar/checkout'

export const BUY_ANCHOR = 'buy'

export function scrollToBuy(): void {
  const el = document.getElementById(BUY_ANCHOR)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

export const IMAGES = {
  boxSet:
    'https://cdn.magicpatterns.com/uploads/4Z1jLpvrfJhSn2KdaWX7TM/Diseno_sin_titulo.png',
  bonus1:
    'https://cdn.magicpatterns.com/uploads/vsMRgBbRd1X6PAsppoSgHb/8911b5b3-a358-4570-922f-4871fac9498b-mockup.webp',
  bonus2:
    'https://cdn.magicpatterns.com/uploads/tAfba5bxDKoB5VaT94AVa1/29da6eb3-8992-4347-8ff9-1c64a46e8672-mockup.webp',
  bonus3:
    'https://cdn.magicpatterns.com/uploads/s1fyx51FKjms1fKntABLB2/8a95fa81-7ccd-4dd9-a46f-65d37d8c0658-mockup.webp',
  bonus4:
    'https://cdn.magicpatterns.com/uploads/4QgGE6PVyni8aMrr5i6Qmb/54caeda6-b295-4bcb-a914-b905219d319d-mockup.webp',
  bonus5:
    'https://cdn.magicpatterns.com/uploads/tSHGjEF1FrkHTuRn5FXz3z/b08bac05-18ab-4cbb-8ea1-5beace057a4a-mockup.webp',
}
